import Stock from '../assets/images/Sidebar Icon/stock.png';
import past from '../assets/images/Sidebar Icon/past.png';

const warehousesidebar = [
    {
        navigation: "/stocklevels",
        icon: Stock,
        label: "Stock Levels",
    },
    // {
    //     navigation: "/itemregistration",
    //     icon: item,
    //     label: "Product",
    // },
    // {
    //     navigation: "/scanbarcode",
    //     icon: scan,
    //     label: "Scan Barcode",
    // },
    {
        navigation: "/pasttransactions",
        icon: past,
        label: "Past Transactions",
    },
    // {
    //     navigation: "/logistic",
    //     icon: logisticImage,
    //     label: "Logistic Staff",
    // },
    // {
    //     navigation: "/company",
    //     icon: company,
    //     label: "Company",
    // },
    // {
    //     navigation: "/warehouse",
    //     icon: warehouse,
    //     label: "Warehouse",
    // }
]

export { warehousesidebar };